import shared from '@/data/seo_shared.json';

export const AUTHOR = shared.author;

// Google: author.name hanya nama, jawatan dalam jobTitle
export const authorJsonLd = () => ({
  '@type': 'Person',
  name: AUTHOR.name,
  alternateName: AUTHOR.display,
  jobTitle: AUTHOR.role,
  url: AUTHOR.url,
  worksFor: { '@type': 'Organization', name: 'Flexa', url: 'https://flexaviral.com' },
});

export const PUBLISHER = {
  '@type': 'Organization',
  name: 'Flexa',
  url: 'https://flexaviral.com',
  logo: { '@type': 'ImageObject', url: 'https://flexaviral.com/favicon-512.png' },
};
